import { z } from 'zod';
import { LOCATION_GROUP_CONSTRAINTS } from './constraints.js';
import { locationGroupNameSchema } from './create-form.js';
import { locationGroupAddressInputSchema } from './create-input.js';
export const updateLocationGroupInputSchema = z
    .object({
    // WHY: trimmed here, not just in the superRefine below -- that one parses a trimmed copy to
    // validate and discards it, so the resolver would otherwise write the untrimmed string.
    name: z.string().trim().nullable().optional(),
    // Same shape the create path validates, so one address rule governs both.
    address: locationGroupAddressInputSchema.optional().nullable(),
})
    .superRefine((input, context) => {
    if (input.name === undefined)
        return;
    if (input.name == null || input.name.trim() === '') {
        context.addIssue({
            code: 'custom',
            message: `${LOCATION_GROUP_CONSTRAINTS.name.label} is required.`,
            path: ['name'],
        });
        return;
    }
    const result = locationGroupNameSchema.safeParse(input.name);
    if (!result.success) {
        context.addIssue({
            code: 'custom',
            message: result.error.issues[0].message,
            path: ['name'],
        });
    }
});
//# sourceMappingURL=update-input.js.map